<template>
  <v-container>
    <v-slide-x-transition>
      <v-data-table
        :headers="prop_headers"
        :items="prop_items"
        class="elevation-1"
        :loading="propsLoading"
        loading-text="Загружаю данные"
        item-key="PROP_PKUUID"
        show-select
        single-select
        :search="propSearch"
        :footer-props="{
          itemsPerPageText: 'На страницу',
          itemsPerPageAllText: 'Все',
          pageText: 'из'
        }"
        dense
        :value="value"
        @input="setValue"
      >
        <template v-slot:top>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>Свойства</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="propSearch"
              append-icon="mdi-magnify"
              label="Искать"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`item.PROP_MIN`]="{ item }">
          {{ numLocaleDecorator(item.PROP_MIN) }}
        </template>
        <template v-slot:[`item.PROP_MAX`]="{ item }">
          {{ numLocaleDecorator(item.PROP_MAX) }}
        </template>
        <template v-slot:[`item.PROP_KOEFF`]="{ item }">
          {{ numLocaleDecorator(item.PROP_KOEFF) }}
        </template>
        <template v-slot:no-data>
          Нет данных
        </template>
      </v-data-table>
    </v-slide-x-transition>
  </v-container>
</template>

<script>

import { UI_SNACKBAR } from '@/store/actions/ui'
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'
import axios from 'axios'

export default {
  name: 'gradePropertiesTable',
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    grade: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mixins: [numDecorator],
  components: {
  },
  data () {
    return {
      prop_headers: [
        { text: 'Свойство', value: 'PROP_NAME' },
        { text: 'Мин', align: 'end', cellClass: ' text-end', value: 'PROP_MIN' },
        { text: 'Макс', align: 'end', cellClass: ' text-end', value: 'PROP_MAX' },
        { text: 'Коэффициенты', align: 'end', cellClass: ' text-end', value: 'PROP_KOEFF' },
        { text: 'Ед.изм.', align: 'end', value: 'EI_NAME' }
      ],
      propsLoading: false,
      propSearch: '',
      selectedProp: [],
      prop_items: []
    }
  },
  watch: {
    grade (val) {
      console.log('gradePropertiesTable grade changed to ', val)
      if (val && val.GRADE_UUID) {
        this.getPropList()
      }
    },
    value (val) {
      console.log('gostPropertiesTable value changed to ', val)
      if (!val || !val.length || !val[0].PROP_PKUUID) return
      const curr = this.prop_items.findIndex(itm => itm.PROP_PKUUID === val[0].PROP_PKUUID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.prop_items.splice(curr, 1)
          return
        }
        this.prop_items.splice(curr, 1, val[0])
      } else {
        this.prop_items.push(val[0])
      }
    }
  },
  computed: {
  },
  mounted: function () {
    if (this.prop_items.length === 0 && this.grade.GRADE_UUID) {
      this.getPropList()
    }
  },
  methods: {
    setValue (val) {
      console.log('gostPropertiesTable setting value to ', val)
      this.$emit('input', val)
    },
    getPropList () {
      this.propsLoading = true
      axios({
        url: '/api/org/references/getFGPropertiesList.php',
        method: 'POST',
        data: { GRADE_UUID: this.grade.GRADE_UUID }
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            this.prop_items.splice(0, this.prop_items.length, ...resp.data.data)
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${err}` })
        })
        .finally(
          this.propsLoading = false
        )
    }
  }
}
</script>
